﻿﻿import { CenterTransplantStatus } from '../enums/index';
import { State } from '../enums/index';
import { IDashIntakeConfig } from './dash-intake-config';

export interface ICenterStatisticsView {
    centerId: number;
    dashIntakeConfig: IDashIntakeConfig;
    centerName: string;
    centerAlias: string;
    dcnDomain: string;
    isParticipant: boolean;
    transplantStatus: CenterTransplantStatus;
    transplantRestartDate: Date;
    isDcnParticipant: boolean;
    isDppParticipant: boolean;
    isRdnParticipant: boolean;
    isFamilyVoucherParticipant: boolean;
    isMicrositeParticipant: boolean;
    isInDonorShield: boolean;
    isDonorShieldParticipant: boolean;
    isInListingService: boolean;
    isAcceptingReferrals: boolean;
    isAdpCenter: boolean;
    isAdpParticipant: boolean;
    isAdpPartner: boolean;
    isPrivate: boolean;
    hasAgreedToFees: boolean;
    city: string;
    state: State;
    stateAbbr: string;
    postalCode: string;
    longitude: number;
    latitude: number;
    nkrTransplantsInPast12Months: number;
    nkrTransplantsInPast12MonthsA2O: number;
    nkrTransplantsInPast12MonthsHighCpra: number;
    nkrAverageExchangeWaitTime: number;
    nkrAverageTransplantWaitTime: number;
    nkrUnmatchedPairs: number;
    nkrTotalTransplants: number;
    nkrPairsTransplantedPercent: number;
    nkrChipsEnrolled: number;
    nkrChipsTransplanted: number;
    performsIncompatibleTransplants: boolean;
    performsDesensitization: boolean;
    performsNonSteroidProtocol: boolean;
    providesDonorInsurance: boolean;
    minNddAge: number;
    maxNddAge: number;
    maxPairWorkups: number;
    donorWorkupWait: number;
    recipientWorkupWait: number;
    cadPatientSurvival1YearPediatric: number;
    cadPatientSurvival3YearPediatric: number;
    cadPatientSurvival1YearAdult: number;
    cadPatientSurvival3YearAdult: number;
    cadGraftSurvival1YearPediatric: number;
    cadGraftSurvival3YearPediatric: number;
    cadGraftSurvival1YearAdult: number;
    cadGraftSurvival3YearAdult: number;
    ldPatientSurvival1YearPediatric: number;
    ldPatientSurvival3YearPediatric: number;
    ldPatientSurvival1YearAdult: number;
    ldPatientSurvival3YearAdult: number;
    ldGraftSurvival1YearPediatric: number;
    ldGraftSurvival3YearPediatric: number;
    ldGraftSurvival1YearAdult: number;
    ldGraftSurvival3YearAdult: number;
    insuranceCarriers: string;
    isKidneyForLifeParticipant: boolean;
    nkrImpliedWaitTime: number;
    distanceInMiles: number;
    lostWageReimbursement: number;
    donorLifeInsurance: number;
    donorDisabilityInsurance: number;
    coverageforUncoveredComplications: number;
    legalRepresentation: number;
    remoteDonation: number;
    patientMicrosites: number;
    otherPrograms: number;
    otherProgramsDetails: string;
    prioritizationForDeceasedDonorTransplant: number;
    travelLodgingReimbursement: number;
    lostWageReimbursementForComplication: number;
    travelLodgingReimbursementForComplication: number;
    prioritizationForLivingDonorTransplant: number;
    advancedDonation: number;
    familyVoucher: number;
    impliedWaitTime: number;
    nkrTransplantsLast12: number;
    a2OLast12: number;
    nonSteroidalProtocol: number;
    donorShieldLostWage: number;
    nldacLostWage: number;
    donorShieldTravelLodging: number;
    nldacTravelLodging: number;
    donorShieldDLI: number;
    donorShieldDDI: number;
    donorShieldCUC: number;
    donorShieldLegalRep: number;
}
